import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
// import { motion } from "framer-motion";
// import { styles } from "./styles.js";
// import { textVariant } from "./utils/motion.js";
import "react-vertical-timeline-component/style.min.css";
import { experiences } from "./constants/index.js";
import { SectionWrapper } from "./hoc/index";

const isMobileView = window.innerWidth <= 630; 

const ExperienceCard = ({ experience }) => {
  return (
    <VerticalTimelineElement
      contentStyle={{
        color: "var(--text-white)",
        background: "var(--exp-card-bg)",
        marginLeft: "0px",
        zIndex: -1,
        border: "1px solid var(--exp-card-border)",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.12)",
        backdropFilter: "blur(6px)",
        ...(isMobileView && { marginLeft: "18px" })
      }}

      contentArrowStyle={{ borderRight: "7px solid var(--exp-card-bg)" }}
      date={<p style={{ textAlign: "center", color: "var(--form-text)" }}>{experience.date}</p>}
      iconStyle={{ background: experience.iconBg }}
      icon={
        <div className='flex justify-center items-center w-full h-full'>
          <img
            src={experience.icon}
            alt={experience.company_name}
            className='w-[60%] h-[60%] object-contain'
            style={{ width: '60%', height: '60%', paddingTop: '10px', objectFit: 'contain' }}
          />
        </div>
      }
    >
      <div>
        <h3 className='text-[24px] font-bold' style={{ color: "var(--text-white)" }}>{experience.title}</h3>
        <p
          className='text-[16px] font-semibold'
          style={{ margin: 0, color: '#62a9df' }}
        >
          {experience.company_name}
        </p>

      </div>

      {
        <ul className='mt-1 list-disc ml-2 space-y-2'>
          {experience.points.map((point, index) => (
            <li
              key={`experience-point-${index}`}
              className='text-[14px] pl-1 tracking-wider text-start'
            >
              <p style={{ color: "var(--text-white)" }}>{point}</p>
            </li>
          ))}
        </ul>

      }
    </VerticalTimelineElement>
  );
};

const Experience = () => {
  return (
    <>
      {/* <motion.div variants={textVariant()}>
        <p className={`${styles.sectionSubText} text-center`}>
          What I have done so far
        </p>
      </motion.div> */}

      <div className='mt-0 flex flex-col'>
        <VerticalTimeline>
          {experiences.map((experience, index) => (
            <ExperienceCard
              key={`experience-${index}`}
              experience={experience}
            />
          ))}
        </VerticalTimeline>
      </div>
    </>
  );
};

export default SectionWrapper(Experience, "work");
